export const redactTokenId = (url: string): string =>
  url.replace(/([?&]tokenId=)[^&#]*/g, "$1REDACTED");
